export const itemIconDoubleClick = {
  Group: (options) => {
    const {
      botId,
      item,
      listItemsRequest,
      getConnectorsRequest,
      changeCurrentFlow,
      getSubflowItems,
      getConnectorsSubflowRequest,
      debounceList,
      groupTrigger,
    } = options;

    if (Array.isArray(debounceList) && debounceList.length > 0) {
      const changePath = window.confirm(
        'Realmente deseja mudar de fluxo enquanto o bot é salvo?'
      );
      if (!changePath) {
        return;
      }
    }

    const { _id: id, title } = item;
    if (botId && id) {
      changeCurrentFlow({ id, blockName: title });
      if (id === botId) {
        listItemsRequest(botId);
        getConnectorsRequest(botId);
      } else {
        getSubflowItems({ botId, itemId: id });
        getConnectorsSubflowRequest(botId, id);
      }
      groupTrigger();
    }
  },
};
